import React from "react";
import { useAuth } from "../provider/AuthProvider";
import Header from "../components/Header";
import Navigation from "../components/Navigation";
import { Outlet } from "react-router-dom";
import Footer from "../components/Footer";
import "./MainLayout.scss";

const MainLayout = () => {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <div className="loading-text">Chargement de l'application...</div>
      </div>
    );
  }

  return (
    <div className="main-layout">
      <Header />
      <nav>
        <Navigation />
      </nav>
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
